module.exports = __webpack_public_path__ + "img/icon_commercial.45ca6ed2.svg";